import { handleAxiosError } from '@/api/helpers';
import { client } from '@/client';
import { useAppDispatch, useAppSelector } from '@/hooks/store';
import { useToast } from '@/hooks/useToast';
import {
  selectCurrentAccount,
  setCurrentAccount,
} from '@/store/features/account';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';

export const useScAutoSchedule = (isPaying = true) => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const queryClient = useQueryClient();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const [autoScheduleEnabled, setAutoScheduleEnabled] = useState(
    currentAccount?.scAutoScheduleEnabled ?? false,
  );

  useEffect(() => {
    setAutoScheduleEnabled(currentAccount?.scAutoScheduleEnabled ?? false);
  }, [currentAccount?.scAutoScheduleEnabled]);

  const toggleAutoSchedule = async (value: boolean) => {
    if (!currentAccount?.id || !isPaying) return;
    setAutoScheduleEnabled(value);
    try {
      const updated = await client.accounts.updateAccount({
        accountId: currentAccount.id,
        updates: { scAutoScheduleEnabled: value },
      });
      dispatch(
        setCurrentAccount({
          ...currentAccount,
          ...updated,
          featureFlagAbility: currentAccount?.featureFlagAbility,
        }),
      );
      queryClient.invalidateQueries(['account', currentAccount.id]);
    } catch (error) {
      setAutoScheduleEnabled(!value);
      handleAxiosError(error as Error | AxiosError, toast);
    }
  };

  return { autoScheduleEnabled, toggleAutoSchedule };
};
